import clsx from 'clsx'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import Flex from '@/shared/ui/Flex'

import styles from './VerticalSteps.module.scss'

export type VerticalStepsProps = {
	items: StepItemProps[]
	minTitle?: boolean
	isRow?: boolean
}

export const VerticalSteps = ({ items, minTitle, isRow }: VerticalStepsProps): JSX.Element => (
	<div className={styles.verticalSteps}>
		<ul className={clsx(styles.list, isRow && styles.listRow)}>
			{items &&
				items.map((item, index) => (
					<StepItem
						title={item.title}
						subtitle={item.subtitle}
						key={index}
						stepNumber={index + 1}
						minTitle={minTitle}
						isRow={isRow}
					/>
				))}
		</ul>
	</div>
)

export type StepItemProps = {
	stepNumber?: number
	title?: string
	subtitle?: string
	minTitle?: boolean
	isRow?: boolean
}

export const StepItem = ({ stepNumber, title, subtitle, minTitle }: StepItemProps): JSX.Element => (
	<li className={styles.item}>
		<div className={styles.itemFlex}>
			<span className={styles.number}>{stepNumber}</span>
			<Flex column>
				{title && (
					<h4
						className={clsx(styles.title, minTitle && styles.titleMin)}
						dangerouslySetInnerHTML={createMarkup(title)}
					/>
				)}
				{subtitle && <p className={styles.subtitle} dangerouslySetInnerHTML={createMarkup(subtitle)} />}
			</Flex>
		</div>
	</li>
)
